(function() {
  function initSmartCommandCenter(root) {
    if (!root || root.dataset.smartCommandInitialized === 'true') return;

    root.dataset.smartCommandInitialized = 'true';

    var modeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-smart-mode]'));
    var kicker = root.querySelector('[data-smart-mode-kicker]');
    var title = root.querySelector('[data-smart-mode-title]');
    var text = root.querySelector('[data-smart-mode-text]');
    var activeMode = root.getAttribute('data-active-mode') || 'arrival';
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!modeButtons.length) return;

    function setActiveMode(modeName) {
      if (!modeName) return;

      var activeButton = null;

      modeButtons.forEach(function(button) {
        var isActive = button.getAttribute('data-smart-mode') === modeName;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (isActive) {
          activeButton = button;
        }
      });

      if (!activeButton) return;

      root.setAttribute('data-active-mode', modeName);

      var progress = activeButton.getAttribute('data-progress') || '72%';
      root.style.setProperty('--scc-progress', progress);

      if (kicker) {
        kicker.textContent = activeButton.getAttribute('data-kicker') || '';
      }

      if (title) {
        title.textContent = activeButton.getAttribute('data-title') || '';
      }

      if (text) {
        text.textContent = activeButton.getAttribute('data-text') || '';
      }
    }

    modeButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        setActiveMode(button.getAttribute('data-smart-mode'));
      });

      button.addEventListener('mouseenter', function() {
        if (!canHover) return;
        setActiveMode(button.getAttribute('data-smart-mode'));
      });

      button.addEventListener('focus', function() {
        if (!canHover) return;
        setActiveMode(button.getAttribute('data-smart-mode'));
      });
    });

    setActiveMode(activeMode);
  }

  function initAllSmartCommandCenters() {
    var roots = document.querySelectorAll('.js-smart-command-center');

    roots.forEach(function(root) {
      initSmartCommandCenter(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSmartCommandCenters);
  } else {
    initAllSmartCommandCenters();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('.js-smart-command-center');

    if (root) {
      root.dataset.smartCommandInitialized = 'false';
      initSmartCommandCenter(root);
    }
  });
})();